module.exports = __webpack_public_path__ + "img/Unidad14-4.30fd0193.png";